<template>
    <div v-show="visible" ref="backdrop" class="backdrop" @click="hideModal">
        <div class="p-5 py-md-10 py-lg-20">
            <div class="row">
                <div class="d-none d-md-block col-xl-3 col-md-1"/>
                <div class="col">
                    <Transition>
                        <div v-if="showCard" ref="card" class="card shadow" @click.stop>
                            <div v-if="$slots.title" class="card-header d-flex flex-row align-items-center">
                                <div class="flex-grow-1">
                                    <div class="font-size-lg font-weight-bold">
                                        <slot name="title"/>
                                    </div>
                                    <div v-if="$slots.subtitle" class="font-size-sm">
                                        <slot name="subtitle"/>
                                    </div>
                                </div>
                                <div v-if="!preventClose">
                                    <i class="fas fa-times cursor-pointer text-hover-warning text-muted"
                                       @click="hideModal"/>
                                </div>
                            </div>
                            <div class="card-body" style="max-height: 70vh; overflow-y: scroll;">
                                <slot/>
                            </div>
                            <div v-if="$slots.footer"
                                 class="card-footer">
                                <slot name="footer"/>
                            </div>
                        </div>
                    </Transition>
                </div>
                <div class="d-none d-md-block col-xl-3 col-md-1"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        preventClose: Boolean
    },

    emits: ['update:visible'],

    data() {
        return {
            isBackdropAligned: false,
            showCard: false
        }
    },

    methods: {
        hideModal() {
            if (this.preventClose) {
                this.bounce();
                return;
            }

            this.forceHideModal();
        },

        forceHideModal() {
            this.showCard = false;
            this.stopListeningForEscape();
            setTimeout(() => {
                this.$emit('update:visible', false);
            }, 240);
        },

        adjustBackdrop() {
            this.$refs.backdrop.style.marginTop = `-${this.$refs.backdrop.getBoundingClientRect().top}px`;
            this.$refs.backdrop.style.marginLeft = `-${this.$refs.backdrop.getBoundingClientRect().left}px`;
            this.isBackdropAligned = true;
        },

        bounce() {
            this.$refs.card.animate(
                [
                    // keyframes
                    {transform: "perspective(800px) translateZ(0px)"},
                    {transform: "perspective(800px) translateZ(2em)"},
                    {transform: "perspective(800px) translateZ(0px)"},
                ],
                {
                    // timing options
                    duration: 240,
                    iterations: 1,
                },
            );
        },

        startListeningForEscape() {
            window.addEventListener('keyup', (e) => {
                if (e.key === "Escape") {
                    this.hideModal();
                }
            })
        },

        stopListeningForEscape() {
            window.removeEventListener('keyup', (e) => {
                if (e.key === "Escape") {
                    this.hideModal();
                }
            })
        }
    },

    watch: {
        visible(newValue, oldValue) {
            if (newValue) {
                if (!this.isBackdropAligned) {
                    this.$nextTick(() => {
                        this.adjustBackdrop();
                    });
                }

                this.showCard = true;
                this.startListeningForEscape();
            } else {
                this.stopListeningForEscape();
            }
        }
    }
}
</script>

<style>
.backdrop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 200;
    background: rgba(0, 0, 0, 0.2);
}
</style>
